<div class="patient-documents-flow">
  <div class="flow-header">
    <span class="flow-title">{{ pageTitle }}</span>
    <button mat-icon-button (click)="closeOrNavigateHome()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="flow-content" *ngIf="isLoadingPatient">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>

  <div class="flow-content flow-content--error" *ngIf="!isLoadingPatient && initError">
    <mat-icon>error_outline</mat-icon>
    <p>{{ initError === 'not-found' ? 'Patient not found.' : 'Failed to load patient data.' }}</p>
  </div>

  <div class="flow-content" *ngIf="!isLoadingPatient && !initError && workspaceReady">
    <!-- Top action buttons: share, upload, library, diagnoses -->
    <app-client-profile-top-buttons
      [addClientUploadCondition]="addClientUploadCondition"
      [currentFolderName]="currentFolderName"
      [importFromAppsBtn]="false"
      [isSpoke]="isSpoke"
      [patientType]="patient?.type"
      [permissions_uploadfiles]="permissions_uploadfiles"
      [realRole]="realRole"
      [selectedHub]="true"
      [showAddConsultant]="false"
      [showBackToOverview]="false"
      [UserRoles]="UserRoles"
      (addConsultantEvent)="addConsultant()"
      (addDiagnosesEvent)="addDiagnoses()"
      (backToOverviewEvent)="backToOverview()"
      (handleAddClientUser)="handleAddClientUser($event)"
      (libraryManagerEvent)="showLibraryManager()"
      (openDialogEvent)="openUploadDialog()"
      (shareFilesEvent)="openShareFilesDialog()"
      (showMyDiagnosesEvent)="showMyDiagnoses()">
    </app-client-profile-top-buttons>

    <!-- Infected files banner -->
    <div *ngIf="infectedFiles && infectedFiles.length" class="infected-files-section mat-small">
      <p>
        The following file(s) has been deleted because of malware found in it. Please click
        <a class="refresh-link refresh-link-inline" href="#" (click)="$event.preventDefault(); handlePostMutationRefresh()">REFRESH</a>
        to update the list of files
      </p>
      <ul>
        <li *ngFor="let file of infectedFiles" class="infected-file infected-file-item">{{ file }}</li>
      </ul>
    </div>

    <!-- Toolbar: refresh, folder creation, search (search is a TODO) -->
    <app-client-profile-toolbar
      [files]="files"
      [permissions_createfolder]="permissions_createfolder"
      [refreshButton]="true"
      (handleRefreshEvent)="handlePostMutationRefresh()"
      (createFolderEvent)="openCreateFolderDialog()"
      (openFileSearchEvent)="openFileSearch()">
    </app-client-profile-toolbar>

    <!-- Folder accordion with wired row/file/folder interactions -->
    <div class="home-folders-accordion-container-box">
      <app-home-folders-accordion
        [casename]="casename"
        [currentFolder]="currentFolder"
        [currentFolderName]="currentFolderName"
        [discsFolderName]="discsFolderName"
        [filesLoaded]="filesLoaded"
        [folders]="accordionFolders"
        [isSearchActive]="isSearchActive"
        [searchResults]="searchResults"
        [loading]="isRefreshing"
        [loadingMessage]="''"
        [ownerID]="ownerID"
        [permissions]="accordionPermissions"
        [realRole]="realRole"
        [UserRoles]="UserRoles"
        [userOwnerID]="userOwnerID"
        (clearSearchResults)="clearSearchResults()"
        (searchResultFileClick)="handleAccordionFileClick($event)"
        (searchResultFileSelectionChange)="handleAccordionFileClick($event)"
        (addCommentOrAttachment)="handleAccordionAddCommentOrAttachment($event)"
        (copyFile)="handleAccordionCopyFile($event)"
        (deleteFile)="handleAccordionDeleteFile($event)"
        (editFile)="handleAccordionEditFile($event)"
        (fileClick)="handleAccordionFileClick($event)"
        (folderClick)="handleAccordionFolderClick($event)"
        (generateDisc)="handleAccordionGenerateDisc($event)"
        (loadFolderContents)="handleAccordionLoadFolderContents($event)"
        (refreshFolderContents)="handleAccordionRefreshFolderContents($event)">
      </app-home-folders-accordion>
    </div>

    <button mat-button (click)="backToOverview()">Back to Overview</button>
  </div>
</div>
